import {connect} from 'react-redux';
import Login, {StateProps, ActionProps, OwnProps} from './Login';
import {AppState} from 'types';

export default connect<StateProps, ActionProps, OwnProps, AppState>(
	() => ({}),
	{}
)(Login);
